import { type ReactNode, useEffect, useState } from 'react';

import { Button } from '@/components/ui/button';

const PHONE = '(max-width: 1023px)';

function usePhone(): boolean {
  const [phone, setPhone] = useState(() => {
    if (typeof window.matchMedia !== 'function') {
      return false;
    }
    return window.matchMedia(PHONE).matches;
  });

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return;
    }
    const media = window.matchMedia(PHONE);
    const onChange = () => setPhone(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  return phone;
}

/** Phone: filters stay closed until opened and then use the full width. Wider screens show them inline. */
export function KnowledgeMobileFilters({ children }: { children: ReactNode }) {
  const phone = usePhone();
  const [open, setOpen] = useState(false);
  if (!phone) {
    return children;
  }
  return (
    <div className="col-span-full flex w-full flex-col gap-2">
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="w-full"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        {open ? 'Filter schließen' : 'Filter'}
      </Button>
      {open ? <div className="grid w-full grid-cols-1 gap-2">{children}</div> : null}
    </div>
  );
}
